import Button from "@shared/components/ui/Button";
import theme from "@shared/utils/themeColors";
import { Link } from "react-router-dom";
import GoogleButton from "./GoogleButton";

// Login form component
const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  onSubmit,
  onGoogleSignIn,
  loading,
  error,
  needsVerification,
  handleVerificationRedirect,
}) => (
  <>
    <h1 className={`text-3xl ${theme.text.primary} font-bold mb-6`}>
      Welcome back!
    </h1>

    {/* Error message */}
    {error && (
      <div className="mb-4">
        <div className="bg-red-50 border-l-4 border-red-400 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-red-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          </div>
        </div>
      </div>
    )}

    {needsVerification && (
      <div className="mt-4 text-center max-w-md mx-auto mb-4">
        <button
          onClick={handleVerificationRedirect}
          className={`text-sm ${theme.text.link} hover:underline`}
        >
          Need to verify your email? Click here
        </button>
      </div>
    )}

    {/* Form */}
    <form onSubmit={onSubmit}>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="email">
            Email Address
          </label>
          <input
            id="email"
            className="form-input w-full"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="form-input w-full"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="on"
            required
          />
        </div>
      </div>
      <div className="flex items-center justify-between mt-6">
        <div className="mr-1">
          <Link
            className="text-sm underline hover:no-underline"
            to="/reset-password"
          >
            Forgot Password?
          </Link>
        </div>
        <Button type="submit" variant="secondary" disabled={loading}>
          {loading ? "Signing in..." : "Sign In"}
        </Button>
      </div>
    </form>

    {/* Google Sign In */}
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className={`px-2 bg-white ${theme.text.muted}`}>
            Or continue with
          </span>
        </div>
      </div>
      <GoogleButton onClick={onGoogleSignIn} disabled={loading} />
    </div>

    {/* Sign up link */}
    <div className="pt-5 mt-6 border-t border-gray-200">
      <div className="text-sm">
        Don't you have an account?{" "}
        <Link
          className="font-medium text-gray-900 hover:text-gray-700"
          to="/signup"
        >
          Sign Up
        </Link>
      </div>
    </div>
  </>
);

export default LoginForm;
